import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function ClarificationCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-sm text-yellow-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-yellow-300 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-yellow-950">
          Clarify
        </span>
        {answer.clarification_kind && (
          <span className="font-mono text-xs text-yellow-800">
            {answer.clarification_kind}
          </span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
